export { CoreServicesModule } from './core-services.module';
export { ServiceSetup } from './service-setup.service';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/core-services/index.ts